export const createKeyboardEventHandler = (
    keyActionMap: Record<string, () => void>,
) => {
    return (e: KeyboardEvent) => {
        const key = e.key.toLowerCase();

        if (e.metaKey || e.ctrlKey) {
            return;
        }

        const keyAction = keyActionMap[key];

        if (keyAction) {
            e.preventDefault();
            keyAction();
        }
    };
};
